
  import { reactive } from "vue";
  import DynamicForm from "@/components/Shared/Dynamicform/DynamicForm.vue";
  
  export default {
    name: "UserPrivacyOnlyRegistrationByCode",
    inheritAttrs: false,
    components: {
      DynamicForm
    },
    setup() {    
      const request = reactive({
        apiLoadMethod: "",
        apiSaveMethod: "api/Form/saveForm",
        form: "Datenschutz",
        page: "RegistrierungBestaetigen",
        remoteId: "",
        waitForResponse: true
        
      });
  
      return {
        request
      };
    }
  };
  